export function JobChangesDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Job Change Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Change Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Type of Change <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select change type</option>
              <option value="new_company">New Company</option>
              <option value="industry_switch">Industry Switch</option>
              <option value="department_transfer">Department Transfer</option>
              <option value="location_change">Location Change</option>
              <option value="career_pivot">Career Pivot</option>
            </select>
          </div>

          {/* Previous Position */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Previous Position <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter previous job title"
            />
          </div>

          {/* New Position */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              New Position <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter new job title"
            />
          </div>

          {/* Previous Company/Department */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Previous Company/Department <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter previous company or department"
            />
          </div>

          {/* New Company/Department */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              New Company/Department <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter new company or department"
            />
          </div>

          {/* Change Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Change Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Previous Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Previous Location
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* New Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              New Location
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 